export class LocalStorage {

  public static readonly token: string = 'token';
  public static readonly modalCongrats: string = 'modalCongrats';
  public static readonly modalGiveUp: string = 'modalGiveUp';

  public static get(key: string) {
    return localStorage.getItem(key);
  };

  public static set(key: string, value: string) {
    return localStorage.setItem(key, value);
  };

  public static remove(key: string) {
    return localStorage.removeItem(key);
  };

  public static isValueTrue(key: string) {
    const value = this.get(key);
    return value && value === 'true';
  };
}
